import { useMutation, useQueryCache } from 'react-query';
import { ParticipantsAPI } from 'api/participant';
import { PARTICIPANT, PARTICIPANTS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateParticipant() {
  const queryCache = useQueryCache();

  return useMutation(ParticipantsAPI.update, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(PARTICIPANT);
      queryCache.invalidateQueries(PARTICIPANTS);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
